/*! Ardor QR code tool v2 (Oct 18, 2026; v2: styles injected by the script, no extra stylesheet request; no window scan while waiting) - Ardor Printing, ardorprinting.com
 * The banner designer kit's QR code generator, for the other designers (A-frame, yard sign, canvas, flag, table cover,
 * banner stand, DTF). Talks to the designer only through window.Ardor<Name>Layers.kit (the designer's "-kit" layers copy).
 * The QR encoder (window.ArdorQR, assets/ardor-kit-qr.js) loads on first use from window.ArdorKitAssets.qr.
 * Settings: window.ArdorQrTool = { layers: 'ArdorFlagLayers', noun: 'flag' } (both optional).
 * Print files are unchanged: the code is an ordinary vector layer (a Fabric group) that the designer flattens into the print
 * file and paints on the 3D view and the proof, exactly like text and clipart.
 */
(function () {
  'use strict';
  if (window.ArdorQrToolBooted) return;
  window.ArdorQrToolBooted = true;

  var CFG = window.ArdorQrTool || {};
  var NOUN = CFG.noun || 'design';
  var K = null, fabric = null, fc = null, booted = false, uiReady = false, loading = null;
  var st = { info: { phone: '', web: '' }, qrEdit: null };
  var ui = {};

  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function toast(m, ms) { try { K.toast(m, ms || 5000); } catch (e) {} }
  function track(k) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'ardor_kit_' + k, ardor_designer: CFG.name || NOUN }); } catch (e) {} }
  function lsGet(k) { try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function failed(e) { try { console.warn('[ardor qr]', e); } catch (x) {} toast('The QR code tool could not load. Please refresh the page and try again.', 6000); }

  function loadQr() {
    if (window.ArdorQR) return Promise.resolve(window.ArdorQR);
    if (loading) return loading;
    loading = new Promise(function (res, rej) {
      var src = (window.ArdorKitAssets || {}).qr;
      if (!src) { rej(new Error('no asset url for qr')); return; }
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { if (window.ArdorQR) res(window.ArdorQR); else rej(new Error('qr')); };
      s.onerror = function () { loading = null; rej(new Error('load qr')); };
      document.head.appendChild(s);
    });
    return loading;
  }
  function findLayers() {
    if (CFG.layers) return window[CFG.layers] && window[CFG.layers].kit ? window[CFG.layers] : null;
    for (var k in window) {
      try { if (/^Ardor\w+Layers$/.test(k) && window[k] && window[k].kit) return window[k]; } catch (e) {}
    }
    return null;
  }
  function canvas() { fc = K.canvas(); return fc; }
  function dims() {
    var b = K.banner();
    var safe = K.safeArea(b.c, b.Wi, b.Hi) || { x: 0, y: 0, w: b.Wi, h: b.Hi };
    return { Wi: b.Wi, Hi: b.Hi, safe: safe };
  }

  // the tool's few styles go in with the script, so the page has no extra render-blocking stylesheet
  var CSS = '.adk-tool .abl-tool-ic svg { width: 22px; height: 22px; } .adk-body { display: flex; flex-direction: column; gap: 12px; } .adk-small { font-size: 12px; } .adk-field { display: flex; flex-direction: column; gap: 4px; font-size: 12px; font-weight: 600; color: #3d3a36; } .adk-field .abl-input { font-weight: 400; } .adk-two { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; } .adk-btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; border: 1px solid #16161b; background: #16161b; color: #fff; border-radius: 10px; padding: 9px 14px; font: inherit; font-size: 13px; font-weight: 700; cursor: pointer; } .adk-btn:disabled { opacity: .4; cursor: not-allowed; } .adk-btn--wide { width: 100%; } .adk-warn { color: #b3121f; font-size: 12px; font-weight: 600; margin: 0; } .adk-qr-preview { display: flex; justify-content: center; align-items: center; min-height: 120px; background: #f1efeb; border-radius: 10px; padding: 10px; } .adk-qr-preview svg { width: 160px; height: 160px; max-width: 100%; } .adk-props-qr { display: flex; flex-direction: column; gap: 8px; margin-top: 4px; } @media (min-width: 901px) { .abx .abx-rail { min-height: 0; max-height: 100%; overflow-y: auto; overflow-x: hidden; scrollbar-width: thin; } }';
  function addCss() {
    if (document.getElementById('ardor-qr-tool-css')) return;
    var s = document.createElement('style'); s.id = 'ardor-qr-tool-css'; s.textContent = CSS; (document.head || document.documentElement).appendChild(s);
  }

  // ---------- boot ----------
  function boot() {
    if (booted) return;
    var L = findLayers();
    if (!L) return;
    K = L.kit; booted = true;
    addCss();
    var saved = lsGet('ardorKitInfo'); if (saved) st.info = { phone: saved.phone || '', web: saved.web || '' };
    if (K.ui() && K.ui().drawer) buildUi();
    else document.addEventListener('ardor:layers-kit-ui', function () { buildUi(); });
  }

  // ---------- UI ----------
  var IC = {
    qr: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="20" height="20"><path d="M6 6l12 12M18 6 6 18"/></svg>'
  };
  function buildUi() {
    if (uiReady) return;
    var u = K.ui(); if (!u || !u.drawer) return;
    uiReady = true; ui.drawer = u.drawer;
    var scope = (u.root || document);
    var rail = $('.abx-rail', scope) || $('.abx-rail');
    var btn = el('button', 'abx-tool abl-tool adk-tool', '<span class="abl-tool-ic" aria-hidden="true">' + IC.qr + '</span><span>QR code</span>');
    btn.type = 'button'; btn.setAttribute('data-abl-tool', 'qr'); btn.setAttribute('aria-expanded', 'false');
    ui.tQr = btn;
    var clipBtn = rail && $('[data-abl-tool="clipart"]', rail), textBtn = rail && $('[data-abl-tool="text"]', rail);
    if (rail && (clipBtn || textBtn)) rail.insertBefore(btn, (clipBtn || textBtn).nextSibling);
    else {
      var host = (textBtn && textBtn.parentNode) || $('.abl-minirail', scope) || rail;
      if (host) host.appendChild(btn);
    }
    btn.addEventListener('click', function () { setTimeout(openQr, 0); });
    buildQrPanel();
    buildPropsExtras();
    if (fcReady()) hookCanvas();
    else K.ready().then(function () { if (fcReady()) hookCanvas(); }).catch(function () {});
  }
  function fcReady() { try { fabric = K.fabric(); canvas(); return !!(fabric && fc); } catch (e) { return false; } }
  var hooked = false;
  function hookCanvas() {
    if (hooked || !fc) return; hooked = true;
    fc.on('selection:created', selSync); fc.on('selection:updated', selSync); fc.on('selection:cleared', selSync);
  }
  function panel(name, title, body) {
    var p = el('div', 'abl-drawer__panel adk-panel', '<div class="abl-drawer__head"><h2>' + title + '</h2><button type="button" class="abl-x" data-adk-close aria-label="Close">' + IC.x + '</button></div><div class="abl-drawer__body adk-body">' + body + '</div>');
    p.setAttribute('data-abl-panel', name); p.hidden = true;
    $('[data-adk-close]', p).addEventListener('click', function () { K.closeDrawer(); });
    ui.drawer.appendChild(p);
    return p;
  }

  // ---------- QR code ----------
  var QR_TYPES = [
    ['url', 'Website', [['url', 'Website address', 'url', 'yourwebsite.com']]],
    ['tel', 'Phone call', [['tel', 'Phone number', 'tel', '(555) 555-5555']]],
    ['sms', 'Text message', [['sms', 'Phone number', 'tel', '(555) 555-5555'], ['body', 'Message (optional)', 'text', '']]],
    ['email', 'Email', [['to', 'Email address', 'email', 'you@yourbusiness.com'], ['subject', 'Subject (optional)', 'text', '']]],
    ['wifi', 'Wi-Fi', [['ssid', 'Network name', 'text', ''], ['pass', 'Password', 'text', ''], ['enc', 'Security', 'select:WPA=WPA / WPA2,WEP=WEP,nopass=No password', 'WPA']]],
    ['vcard', 'Contact card', [['name', 'Name', 'text', ''], ['org', 'Business', 'text', ''], ['phone', 'Phone', 'tel', ''], ['email', 'Email', 'email', ''], ['url', 'Website', 'url', '']]],
    ['text', 'Plain text', [['text', 'Text', 'textarea', '']]]
  ];
  function addLabel() { return 'Add QR code to my ' + NOUN; }
  function buildQrPanel() {
    var opts = QR_TYPES.map(function (t) { return '<option value="' + t[0] + '">' + t[1] + '</option>'; }).join('');
    var p = panel('qr', 'QR code',
      '<p class="abl-help">Make a QR code people can scan from your ' + esc(NOUN) + '. It prints sharp at any size.</p>' +
      '<label class="adk-field"><span>What should it open?</span><select class="abl-input" data-adk-qr-type>' + opts + '</select></label>' +
      '<div data-adk-qr-fields></div>' +
      '<div class="adk-two"><label class="adk-field"><span>Style</span><select class="abl-input" data-adk-qr-style><option value="square">Square</option><option value="rounded">Rounded</option></select></label>' +
      '<label class="adk-field"><span>Corners</span><select class="abl-input" data-adk-qr-finder><option value="square">Square</option><option value="rounded">Rounded</option></select></label></div>' +
      '<div class="adk-two"><label class="adk-field"><span>Code color</span><span class="abl-color"><input type="color" value="#000000" data-adk-qr-fg aria-label="QR code color"></span></label>' +
      '<label class="adk-field"><span>Behind the code</span><span class="abl-color"><input type="color" value="#ffffff" data-adk-qr-bg aria-label="QR code background color"></span></label></div>' +
      '<p class="adk-warn" data-adk-qr-warn hidden></p>' +
      '<div class="adk-qr-preview" data-adk-qr-preview></div>' +
      '<button type="button" class="adk-btn adk-btn--wide" data-adk-qr-add>' + esc(addLabel()) + '</button>' +
      '<p class="abl-help adk-small" data-adk-qr-size></p>' +
      '<p class="abl-help adk-small">Tip: test it with your phone camera on the proof before you order. Make the code about 1 in wide for every 10 in of scanning distance (about 12 in wide for people 10 ft away).</p>');
    ui.qrPanel = p; ui.qrType = $('[data-adk-qr-type]', p); ui.qrFields = $('[data-adk-qr-fields]', p);
    ui.qrPrev = $('[data-adk-qr-preview]', p); ui.qrWarn = $('[data-adk-qr-warn]', p); ui.qrAdd = $('[data-adk-qr-add]', p); ui.qrSize = $('[data-adk-qr-size]', p);
    ui.qrType.addEventListener('change', function () { qrFields(); qrPreview(); });
    ['[data-adk-qr-style]', '[data-adk-qr-finder]', '[data-adk-qr-fg]', '[data-adk-qr-bg]'].forEach(function (s) { $(s, p).addEventListener('input', qrPreview); });
    ui.qrAdd.addEventListener('click', addQr);
    qrFields();
  }
  function qrFields(vals) {
    var t = QR_TYPES.filter(function (x) { return x[0] === ui.qrType.value; })[0];
    vals = vals || {};
    ui.qrFields.textContent = '';
    t[2].forEach(function (f) {
      var lab = el('label', 'adk-field', '<span>' + esc(f[1]) + '</span>'), inp;
      if (f[2] === 'textarea') { inp = el('textarea', 'abl-input abl-textarea'); inp.rows = 3; }
      else if (f[2].indexOf('select:') === 0) {
        inp = el('select', 'abl-input');
        f[2].slice(7).split(',').forEach(function (o) { var kv = o.split('='), op = el('option'); op.value = kv[0]; op.textContent = kv[1]; inp.appendChild(op); });
      } else { inp = el('input', 'abl-input'); inp.type = f[2] === 'url' ? 'text' : f[2]; if (f[2] === 'url') inp.setAttribute('inputmode', 'url'); }
      inp.setAttribute('data-adk-qf', f[0]);
      if (f[3] && inp.tagName !== 'SELECT') inp.placeholder = f[3];
      var v = vals[f[0]] != null ? vals[f[0]] : (f[0] === 'url' && ui.qrType.value === 'url' ? st.info.web : (f[0] === 'tel' ? st.info.phone : ''));
      if (inp.tagName === 'SELECT') inp.value = vals[f[0]] || f[3]; else inp.value = v || '';
      inp.addEventListener('input', qrPreview);
      lab.appendChild(inp); ui.qrFields.appendChild(lab);
    });
  }
  function qrValues() { var v = {}; $$('[data-adk-qf]', ui.qrFields).forEach(function (i) { v[i.getAttribute('data-adk-qf')] = i.value.replace(/^\s+|\s+$/g, ''); }); return v; }
  function qrPayload(type, v) {
    var P = window.ArdorQR.payload;
    if (type === 'url') return v.url ? P.url(v.url) : '';
    if (type === 'tel') return v.tel ? P.tel(v.tel.replace(/[^\d+]/g, '')) : '';
    if (type === 'sms') return v.sms ? P.sms(v.sms.replace(/[^\d+]/g, ''), v.body || '') : '';
    if (type === 'email') return v.to ? P.email(v.to, v.subject || '', '') : '';
    if (type === 'wifi') return v.ssid ? P.wifi(v.ssid, v.pass || '', v.enc || 'WPA', false) : '';
    if (type === 'vcard') return (v.name || v.org) ? P.vcard({ name: v.name, org: v.org, phone: v.phone, email: v.email, url: v.url }) : '';
    return v.text ? P.text(v.text) : '';
  }
  function qrSettings() {
    var p = ui.qrPanel;
    return { type: ui.qrType.value, v: qrValues(), style: $('[data-adk-qr-style]', p).value, finder: $('[data-adk-qr-finder]', p).value, fg: $('[data-adk-qr-fg]', p).value, bg: $('[data-adk-qr-bg]', p).value };
  }
  function openQr() {
    loadQr().then(function () {
      if (!fc) fcReady();
      hookCanvas();
      var a = fc && fc.getActiveObject();
      if (a && a.ablKind === 'qr' && a.ablQr) { loadQrSettings(a); }
      else { st.qrEdit = null; ui.qrAdd.textContent = addLabel(); }
      qrPreview();
    }).catch(failed);
  }
  function loadQrSettings(o) {
    var s = null; try { s = typeof o.ablQr === 'string' ? JSON.parse(o.ablQr) : o.ablQr; } catch (e) {}
    if (!s || !s.type) return;
    st.qrEdit = o;
    ui.qrType.value = s.type; qrFields(s.v || {});
    $('[data-adk-qr-style]', ui.qrPanel).value = s.style || 'square';
    $('[data-adk-qr-finder]', ui.qrPanel).value = s.finder || 'square';
    $('[data-adk-qr-fg]', ui.qrPanel).value = s.fg || '#000000';
    $('[data-adk-qr-bg]', ui.qrPanel).value = s.bg || '#ffffff';
    ui.qrAdd.textContent = 'Update this QR code';
  }
  function qrPreview() {
    if (!window.ArdorQR || !ui.qrPrev) return;
    var s = qrSettings(), data = qrPayload(s.type, s.v), Q = window.ArdorQR;
    ui.qrWarn.hidden = true;
    if (!data) { ui.qrPrev.innerHTML = '<p class="abl-help">Fill in the details above to see your code.</p>'; ui.qrAdd.disabled = true; qrSizeNote(); return; }
    try {
      var q = Q.encode(data, 'M');
      ui.qrPrev.innerHTML = Q.svg(q, { fg: s.fg, bg: s.bg, px: 180, quiet: 4, style: s.style, finder: s.finder });
      ui.qrAdd.disabled = false;
      if (!Q.ok(s.fg, s.bg)) { ui.qrWarn.textContent = 'Phones scan best with a dark code on a light background. These colors may not scan.'; ui.qrWarn.hidden = false; }
    } catch (e) { ui.qrPrev.innerHTML = '<p class="adk-warn">That is too long for a QR code. Please shorten it.</p>'; ui.qrAdd.disabled = true; }
    qrSizeNote();
  }
  function qrSizeNote() {
    var o = st.qrEdit || (fc && fc.getActiveObject());
    if (!ui.qrSize || !window.ArdorQR) return;
    if (o && o.ablKind === 'qr') { var w = o.getScaledWidth(); ui.qrSize.textContent = 'On your ' + NOUN + ' this code is ' + (Math.round(w * 10) / 10) + ' in wide: easy to scan from about ' + Math.max(1, Math.round(window.ArdorQR.scanDistanceFt(w))) + ' ft away.'; }
    else ui.qrSize.textContent = '';
  }
  function makeQrGroup(s, data, sizeIn) {
    var Q = window.ArdorQR, q = Q.encode(data, 'M');
    var p = Q.path(q, { quiet: 0, style: s.style, finder: s.finder });
    var code = new fabric.Path(p.d, { fill: s.fg, fillRule: 'evenodd', stroke: null, strokeWidth: 0, originX: 'center', originY: 'center' });
    var u = (sizeIn * 0.84) / Math.max(code.width || 1, code.height || 1);
    code.set({ scaleX: u, scaleY: u, left: 0, top: 0 });
    var r = sizeIn * 0.06;
    var plate = new fabric.Rect({ width: sizeIn, height: sizeIn, rx: r, ry: r, fill: s.bg, originX: 'center', originY: 'center', left: 0, top: 0, strokeWidth: 0 });
    return new fabric.Group([plate, code], { originX: 'center', originY: 'center', ablKind: 'qr', ablLabel: 'QR code', ablRole: 'qr', ablQr: JSON.stringify(s), lockScalingFlip: true });
  }
  // default size and spot: wide designs get the code at the right, tall ones in the lower part (not down by the floor or
  // the stand's base), square ones at the bottom right. Customers can move and resize it like any other item.
  function defaultSpot(z) {
    var S = z.safe, r = S.w / Math.max(0.01, S.h), sz, x, y;
    if (r >= 1.6) { sz = Math.min(S.h * 0.46, S.w * 0.26, 30); x = S.x + S.w - sz / 2 - S.w * 0.04; y = S.y + S.h / 2; }
    else if (r < 0.85) { sz = Math.min(S.w * 0.4, S.h * 0.26, 30); x = S.x + S.w / 2; y = Math.min(S.y + S.h * 0.7, S.y + S.h - sz / 2 - S.h * 0.04); }
    else { sz = Math.min(S.w, S.h) * 0.34; sz = Math.min(sz, 30); x = S.x + S.w - sz / 2 - S.w * 0.05; y = S.y + S.h - sz / 2 - S.h * 0.05; }
    return { sz: Math.max(0.6, sz), x: x, y: y };
  }
  function addQr() {
    Promise.all([K.ready(), loadQr()]).then(function () {
      fabric = K.fabric(); canvas(); hookCanvas();
      var s = qrSettings(), data = qrPayload(s.type, s.v);
      if (!data) return;
      K.targetFace();
      var z = dims(), spot = defaultSpot(z), sz = spot.sz;
      var old = st.qrEdit && fc.getObjects().indexOf(st.qrEdit) >= 0 ? st.qrEdit : null;
      if (old) sz = old.getScaledWidth();
      var g = makeQrGroup(s, data, sz);
      K.look(g);
      if (old) {
        g.set({ left: old.left, top: old.top, angle: old.angle || 0 });
        var idx = fc.getObjects().indexOf(old);
        K.setQuiet(true); fc.remove(old); fc.insertAt(g, idx); K.setQuiet(false);
        fc.setActiveObject(g); g.setCoords(); K.changed(true); K.syncProps();
      } else {
        g.set({ left: spot.x, top: spot.y });
        K.place(g);
      }
      st.qrEdit = g; ui.qrAdd.textContent = 'Update this QR code';
      qrSizeNote();
      track('qr_' + s.type);
    }).catch(failed);
  }

  // ---------- properties panel (title, size note, Edit QR code) ----------
  function buildPropsExtras() {
    var props = K.ui().props; if (!props) return;
    var qrBox = el('div', 'adk-props-qr', '<p class="abl-help" data-adk-pqr-size></p><button type="button" class="abl-done" data-adk-pqr-edit>Edit QR code</button>');
    qrBox.setAttribute('data-abl-p', 'qr'); qrBox.hidden = true;
    props.appendChild(qrBox);
    ui.pQr = qrBox;
    $('[data-adk-pqr-edit]', qrBox).addEventListener('click', function () { if (ui.tQr) ui.tQr.click(); });
    var tt = K.ui().pTitle;
    if (tt && window.MutationObserver) new MutationObserver(function () {
      var o = fc && fc.getActiveObject(); if (!o) return;
      if (o.ablKind === 'qr' && tt.textContent !== 'QR code') tt.textContent = 'QR code';
    }).observe(tt, { childList: true, characterData: true, subtree: true });
  }
  function selSync() {
    var o = fc && fc.getActiveObject(), u = K.ui();
    if (o && o.ablKind === 'qr' && u && u.pTitle) {
      u.pTitle.textContent = 'QR code';
      var w = o.getScaledWidth(), sz = $('[data-adk-pqr-size]', ui.pQr);
      if (sz && window.ArdorQR) sz.textContent = Math.round(w * 10) / 10 + ' in wide. Easy to scan from about ' + Math.max(1, Math.round(window.ArdorQR.scanDistanceFt(w))) + ' ft.';
      else if (sz) loadQr().then(function () { selSync(); }).catch(function () {});
      if (ui.qrPanel && !ui.qrPanel.hidden) { loadQrSettings(o); qrPreview(); }
    }
  }

  window.ArdorQrToolApi = { v: 2, open: function () { if (ui.tQr) ui.tQr.click(); }, state: st };
  document.addEventListener('ardor:layers-kit', boot);
  boot();
  var tries = 0, t = setInterval(function () { if (booted || ++tries > 60) { clearInterval(t); return; } boot(); }, 500);
})();
